import { createEffect } from 'effector'
import { FavoriteGenreAndGames } from './types/types'
import { getRecommendations, getSteamAuthUrl, getSteamRefreshData } from './api'
import { onError } from '@/app/routing/events'



export const getRecommendationsFx = createEffect(async (token: string) => {
  const data: FavoriteGenreAndGames = await getRecommendations(token)

  return data
})

export const getSteamRefreshFx = createEffect(async (token: string) => {
  const data = await getSteamRefreshData(token)
  return data
})
getSteamRefreshFx.failData.watch(() => {
  onError()
})






export const getSteamAuthUrlFx = createEffect(async (userToken: string) => {
  const data = await getSteamAuthUrl(userToken)
  return data
})
getSteamAuthUrlFx.failData.watch(() => {
  onError()
})
